<p-dialog
  [dismissableMask]="false"
  [closable]="true"
  [closeOnEscape]="true"
  (onHide)="closeDialog()"
  [(visible)]="displayDialog"
  showEffect="fade"
  [style]="{'width':'1010px','height':utils.getWindowAvailableHeight(100)+'px'}"
  [contentStyle]="{'overflow':'hidden'}"
  [modal]="true"
  #pDialog>

  <ng-container *ngIf="!utils.isNullOrEmpty(pDialog)">
    <ng-template pTemplate="header">
      <div class="p-dialog-title">
        <yo-help class="mg-r-15" lang="fr" [file]="pathFile" [dialogMsgSupplier]="help()" [width]="800"></yo-help>
        <span [innerHTML]="domSanitizer.bypassSecurityTrustHtml(getTitle(produitDeclinaison))"> </span>
      </div>
    </ng-template>

    <div [style.height.px]="utils.getWindowAvailableHeight(240)" style="overflow-y:auto;overflow-x: hidden;">
      <yo-form [groups]="groups" [form]="form" [options]="{'width':980}"></yo-form>
    </div>

    <ng-template pTemplate="footer">
      <div class="d-flex">
        <div class="mr-auto">
        </div>
        <div *ngIf="multiSites && denree">
          <yo-button buttonClass="" iconClass="fas fa-cubes" [theme]="ButtonThemeEnum.DEFAULT" (onClick)="openGestionStockMini()" tooltip="Gestion du stock minimum"></yo-button>
        </div>
        <div>
          <yo-button
            iconClass="fas fa-random"
            [theme]="ButtonThemeEnum.DEFAULT"
            (onClick)="openDialogChangeUniteTechnique()"
            tooltip="Changer l'unité technique"></yo-button>
        </div>
        <div>
          <yo-button iconClass="fas fa-save"
            [theme]="ButtonThemeEnum.SAVE" (onClick)="saveProduitDeclinaison()"
                     [disabled]="!gds.canModify(produitDeclinaison)" tooltip="Enregistrer"></yo-button>
        </div>
        <div>
          <yo-button *ngIf="produitDeclinaison?.id !== 0" iconClass="fas fa-trash"
            [theme]="ButtonThemeEnum.DELETE"
                     (onClick)="openDeleteDialog(produitDeclinaison)"
                     [disabled]="!canDelete(produitDeclinaison)"
                     tooltip="Supprimer">
          </yo-button>
        </div>
        <div>
          <yo-button iconClass="fas fa-times"
            [theme]="ButtonThemeEnum.CANCEL" tooltip="Fermer" (onClick)="closeDialog()"></yo-button>
        </div>
      </div>
    </ng-template>
  </ng-container>
</p-dialog>


<yo-dialog-change-unite-technique></yo-dialog-change-unite-technique>
<yo-gestion-stock-minimum-dialog [produitDeclinaison]="produitDeclinaison" *ngIf="gds.canModify(produitDeclinaison)"></yo-gestion-stock-minimum-dialog>
